export default __webpack_public_path__ + "static/media/others.41961068.svg";